
/**
 * Check if the current key exists in the target object tree. The Key value needs to in dot notation like 'data.key.child.id'
 * 
 * NULL: if checking the type, null returns false for object comparison
 * ARRAY: Return true on both types "object" and "array". If the key needs to specifically be an array, use type type string "array"
 * 
 * @param {*} key 
 * @param {*} target 
 */
export default function keyExists(key, target, type=false, returnValue=false) {

    function traverse(targ, keys, type=false) {
        const [k, ...rest] = keys;
        
        if(targ[k] === undefined) {
            return false;
        }
        if(rest.length > 0) {
            if(targ[k] === null) {
                return false;    
            }
            return traverse(targ[k], rest, type);
        }
        
        if(type) {
            if(targ[k] === null) {
                return type === "null" ? true : false;
            }

            if(type === "array") {
                return Array.isArray(targ[k]);
            }
            
            if(typeof targ[k] === type) {
                return true;
            } else {
                return false;
            }
        }
        
        if(returnValue) {
            return targ[k];
        }
        return true;
    }

    const keys = Array.isArray(key) ? key : 
        typeof key === "string" ? key.split(".") : [];
            

    return traverse(target, keys, type);
    

}